import React, { useEffect } from 'react';
import styled from 'styled-components';
import { MainContent } from '../App';

const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
`;

const SuccessMessage = styled.div`
  background: linear-gradient(135deg, rgba(20, 30, 48, 0.95), rgba(36, 59, 85, 0.95));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 60px 40px;
  text-align: center;
  backdrop-filter: blur(20px);
  max-width: 600px;
  width: 100%;
  
  @media (max-width: 768px) {
    padding: 40px 30px;
    max-width: 90%;
  }
`;

const SuccessIcon = styled.div`
  font-size: 80px;
  color: #4CAF50;
  margin-bottom: 30px;
  
  @media (max-width: 768px) {
    font-size: 60px;
    margin-bottom: 20px;
  }
`;

const SuccessTitle = styled.h1`
  font-family: 'CocomatPro', sans-serif;
  font-size: 42px;
  font-weight: bold;
  color: white;
  margin: 0 0 20px 0;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
  
  @media (max-width: 768px) {
    font-size: 32px;
  }
  
  @media (max-width: 480px) {
    font-size: 28px;
  }
`;

const SuccessSubtitle = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 30px 0;
  line-height: 1.5;
  
  @media (max-width: 768px) {
    font-size: 18px;
  }
  
  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const SuccessDetails = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  margin-bottom: 40px;
  
  p {
    margin: 0 0 15px 0;
  }
  
  .highlight {
    color: #fcce00;
    font-weight: bold;
  }
  
  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

const BackButton = styled.button`
  font-family: 'CocomatPro', sans-serif;
  background: linear-gradient(100deg, #fcce00, #f7931e);
  border: none;
  border-radius: 25px;
  padding: 15px 35px;
  color: white;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  text-transform: uppercase;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
  letter-spacing: 1px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(252, 206, 0, 0.4);
  }
  
  @media (max-width: 768px) {
    padding: 12px 30px;
    font-size: 14px;
  }
`;

const SuccessPage: React.FC = () => {
  useEffect(() => {
    // Update meta tags for social media previews
    const updateMetaTags = () => {
      // Update Open Graph tags
      const ogTitle = document.querySelector('meta[property="og:title"]');
      const ogDescription = document.querySelector('meta[property="og:description"]');
      const ogImage = document.querySelector('meta[property="og:image"]');
      
      if (ogTitle) ogTitle.setAttribute('content', '¡Compra Exitosa! - FootballClub');
      if (ogDescription) ogDescription.setAttribute('content', 'Tu compra del Pack +Media FC ha sido procesada correctamente. ¡Ya formas parte de la familia FootballClub!');
      if (ogImage) ogImage.setAttribute('content', `${process.env.REACT_APP_DOMAIN || window.location.origin}/sharing-image-whatsapp.jpeg`);
      
      // Update Twitter Card tags
      const twitterTitle = document.querySelector('meta[name="twitter:title"]');
      const twitterDescription = document.querySelector('meta[name="twitter:description"]');
      const twitterImage = document.querySelector('meta[name="twitter:image"]');
      
      if (twitterTitle) twitterTitle.setAttribute('content', '¡Compra Exitosa! - FootballClub');
      if (twitterDescription) twitterDescription.setAttribute('content', 'Tu compra del Pack +Media FC ha sido procesada correctamente. ¡Ya formas parte de la familia FootballClub!');
      if (twitterImage) twitterImage.setAttribute('content', `${process.env.REACT_APP_DOMAIN || window.location.origin}/sharing-image-whatsapp.jpeg`);
      
      // Update page title
      document.title = '¡Compra Exitosa! - FootballClub';
    };
    
    updateMetaTags();
  }, []);

  const handleBackToHome = () => {
    window.location.href = '/';
  };

  return (
    <MainContent>
      <CenteredContainer>
        <SuccessMessage>
          <SuccessIcon>✓</SuccessIcon>
          <SuccessTitle>¡Compra Exitosa!</SuccessTitle>
          <SuccessSubtitle>
            Tu compra del Pack +Media FC ha sido procesado correctamente
          </SuccessSubtitle>
          
          <SuccessDetails>
            <p>
              <span className="highlight">¡Felicidades!</span> Ya formas parte de la familia FootballClub.
            </p>
            <p>
              En las próximas horas recibirás un email con toda la información 
              para acceder a tu contenido exclusivo.
            </p>
            <p>
              Podrás disfrutar de todos los partidos de tu equipo favorito 
              durante toda la temporada.
            </p>
          </SuccessDetails>
          
          <BackButton onClick={handleBackToHome}>
            Volver al inicio
          </BackButton>
        </SuccessMessage>
      </CenteredContainer>
    </MainContent>
  );
};

export default SuccessPage;